// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
  width: 390px !important;
}
.email-title {
  font-size: 28px;
  font-weight: 800;
  line-height: 28px;
  padding-inline: 36px;
  text-align: center;
}
.email-formWrapper {
  height: 54px;
  margin-top: 36px;
}
.email-formWrapper .ant-form-item-control-input-content input {
  height: 54px;
  line-height: 54px;
  border: 1px solid #EAEFF4;
  border-radius: 16px;
  font-family: Darker Grotesque;
  font-size: 18px;
  font-weight: 400;
  color: #1C1C1C;
}
.email-formWrapper .ant-form-item-control-input-content input:hover,
.email-formWrapper .ant-form-item-control-input-content input:active,
.email-formWrapper .ant-form-item-control-input-content input:focus {
  box-shadow: unset;
  border: 1px solid #1C1C1C;
}
.email-btn {
  margin-block: 32px 20px;
}
.email-desc {
  padding-inline: 25px;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: #595D68;
}
@media screen and (max-width: 452px) {
  .modal-wrapper {
    width: 310px !important;
  }
  .email-title {
    font-size: 24px;
    line-height: 26px;
    padding-inline: 20px;
  }
  .email-formWrapper {
    margin-top: 42px;
  }
  .email-formWrapper .ant-form-item-control-input-content input {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
  }
  .email-btn {
    height: 48px;
    margin-block: 24px 20px;
  }
  .email-btn > span {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
  .email-desc {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    padding-inline: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/SendEmailModal/style.less"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AADJ;AAIE;EACE,YAAA;EACA,gBAAA;AAFJ;AAAE;EAMM,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHR;AAVE;;;EAmBM,iBAAA;EACA,yBAAA;AAJR;AASE;EACE,uBAAA;AAPJ;AAUE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AARJ;AAYA;EACE;IACE,uBAAA;EAVF;EAaE;IACE,eAAA;IACA,iBAAA;IACA,oBAAA;EAXJ;EAcE;IACE,gBAAA;EAZJ;EAWE;IAKM,YAAA;IACA,iBAAA;IACA,mBAAA;EAbR;EAkBE;IACE,YAAA;IACA,uBAAA;EAhBJ;EAcE;IAKI,eAAA;IACA,iBAAA;IACA,gBAAA;EAhBN;EAoBE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBAAA;EAlBJ;AACF","sourcesContent":[".modal-wrapper {\n  width: 390px !important;\n}\n\n.email {\n  &-title {\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 28px;\n    padding-inline: 36px;\n    text-align: center;\n  }\n  \n  &-formWrapper {\n    height: 54px;\n    margin-top: 36px;\n\n    .ant-form-item-control-input-content {\n      input {\n        height: 54px;\n        line-height: 54px;\n        border: 1px solid #EAEFF4;\n        border-radius: 16px;\n        font-family: Darker Grotesque;\n        font-size: 18px;\n        font-weight: 400;\n        color: #1C1C1C;\n      }\n\n      input:hover,\n      input:active,\n      input:focus {\n        box-shadow: unset;\n        border: 1px solid #1C1C1C;\n      }\n    }\n  }\n \n  &-btn {\n    margin-block: 32px 20px;\n  }\n\n  &-desc {\n    padding-inline: 25px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: center;\n    color: #595D68;\n  }\n}\n\n@media screen and (max-width: 452px) {\n  .modal-wrapper {\n    width: 310px !important;\n  }\n  .email {\n    &-title {\n      font-size: 24px;\n      line-height: 26px;\n      padding-inline: 20px;\n    }\n\n    &-formWrapper {\n      margin-top: 42px;\n\n      .ant-form-item-control-input-content {\n        input {\n          height: 48px;\n          line-height: 48px;\n          border-radius: 12px;\n        }\n      }\n    }\n\n    &-btn {\n      height: 48px;\n      margin-block: 24px 20px;\n\n      > span {\n        font-size: 20px;\n        line-height: 28px;\n        font-weight: 600;\n      }\n    }\n\n    &-desc {\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 22px;\n      padding-inline: unset;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
